/**
 * wrapper for the VIS graph library
 * http://visjs.org/docs/network/
 */
class jfNetworkController {

  constructor() {

  }

}

export function jfNetwork() {
  return {
    scope: {},
    controller: jfNetworkController,
    controllerAs: 'jfNetwork',
    bindToController: true,
    templateUrl: 'directives/jf_network/jf_network.html'
  }
}



// WEBPACK FOOTER //
// ./modules/xray/directives/jf_network/jf_network.js